<template>
  <!-- 機器追加 -->
  <div id="DeviceAdd">
    <div id="container">
      <deviceNavi v-bind:pageid='"DeviceAdd"'></deviceNavi>
      <div class="labelTitle lable">機器追加</div>
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>品目コード</th>
            <td><input type="text" name="品目コード" class="add-validate" validate="required" v-model="itemCode" @input="itemName = getItemName(itemCode)"/></td>
            <th>品目名称</th>
            <td>{{itemName}}</td>
          </tr>
          <tr>
            <th>シリアル番号</th>
            <td><input type="text" v-model="serial" @keyup.enter="onKeyupEnter()" maxlength="20"/></td>
            <th>保管場所</th>
            <td><input type="text" v-model="storage" maxlength="100"/></td>
          </tr>
          <tr>
            <th>入庫日</th>
            <td><input type="date" name="入庫日" class="add-validate" validate="date" v-model="warehousingDate"/></td>
            <th>リース開始日</th>
            <td><input type="date" name="リース開始日" class="add-validate" validate="date" v-model="leaseStartDate"/></td>
          </tr>
          <tr>
            <th>リース終了日</th>
            <td><input type="date" name="リース終了日" class="add-validate" validate="date" v-model="leaseEndDate"/></td>
            <th>リースアップ日</th>
            <td><input type="date" name="リースアップ日" class="add-validate" validate="date" v-model="leaseUpDate"/></td>
          </tr>
        </table>
      </div>
      <div class="button-area">
        <b-button class="addButton is-primary" @click="addDevice">追加</b-button>
      </div>
      <div class="button-area">
            <b-upload style="float:right; margin-left:5px;" v-model="tsvfile" @input="tsvLoad">
              <a class="button">TSV取り込み</a>
            </b-upload>
            <b-button style="float:right; margin-left:5px;" @click="clearAll">全てクリア</b-button>
      </div>
      <div class="" v-if="data.length > 0">
        <span class="result-count">件数：{{data.length}}件</span>
        <b-table
            id="deviceAddTable"
            :data="data">
            <template slot-scope="props">
              <b-table-column label="#" width="50" centered >
                {{props.index + 1}}
              </b-table-column>
              <b-table-column field="itemCode" label="品目コード" width="100" centered >
                {{props.row.itemCode}}
              </b-table-column>
              <b-table-column field="itemName" label="品目名称" width="300">
                {{props.row.itemName}}
              </b-table-column>
              <b-table-column field="serial" label="シリアル番号" width="140" centered>
                <input type="text" ref="focus" class="regist-validate serial" validate="required" v-model="props.row.serial" @keyup.enter="onKeyupEnterRow(props.row, props.index)" maxlength="20"/>
              </b-table-column>
              <b-table-column field="storage" label="保管場所" width="200">
                <input type="text" v-model="props.row.storageLocation" maxlength="100"/>
              </b-table-column>
              <b-table-column field="warehousingDate" label="入庫日" width="50" centered >
                  <input type="date" name="入庫日" class="regist-validate" validate="date" v-model="props.row.warehousingDate" />
              </b-table-column>
              <b-table-column field="leaseStartDate" label="リース開始日" width="50" centered >
                  <input type="date" name="リース開始日" class="regist-validate" validate="date" v-model="props.row.leaseStartDate" />
              </b-table-column>
              <b-table-column field="leaseEndDate" label="リース終了日" width="50" centered >
                  <input type="date" name="リース終了日" class="regist-validate" validate="date" v-model="props.row.leaseEndDate" />
              </b-table-column>
              <b-table-column field="leaseUpDate" label="リースアップ日" width="50" centered >
                  <input type="date" name="リースアップ日" class="regist-validate" validate="date" v-model="props.row.leaseUpDate" />
              </b-table-column>
              <b-table-column field="delete" label="削除" width="50" centered >
                <b-button class="clearButton" @click="clear(props.index)" icon-left="eraser"></b-button>
              </b-table-column>
            </template>
        </b-table>
      </div>
      <div class="button-area">
        <b-button class="is-primary" @click="deviceRegist" :disabled="!data.length">機器登録</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/device/DeviceNaviBar";
const columnDef =  {'itemCode': 0, 'serial': 1, 'storage': 2, 'warehousingDate': 3, 'leaseStartDate': 4, 'leaseEndDate': 5, 'leaseUpDate': 6}

export default {
  name: "DeviceAdd",
  methods: {
    addDevice: function(){
      var elements = document.getElementsByClassName("add-validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage(errMsg)
      }else if (errMsg != ""){
        this.showErrorMessage(errMsg)
      }else if (!this.itemName){
        this.showErrorMessage("正しい品目コードを指定してください。");
      } else {
        var item = {
          itemCode : this.itemCode,
          itemName : this.itemName,
          serial: this.serial,
          storageLocation: this.storage,
          warehousingDate: this.warehousingDate,
          leaseStartDate: this.leaseStartDate,
          leaseEndDate: this.leaseEndDate,
          leaseUpDate : this.leaseUpDate,
        }

        this.data.push(item);
      }
    },
    clearAll: function(){
      this.data = [];
    },
    tsvLoad: async function(){
      var appVue = this.$root.$children[0] 
      appVue.loadingStart()

      var _this = this;
      var reader = new FileReader();
      var parent = this;
      var encoding = await this.getEncoding(this.tsvfile)
      reader.readAsText( this.tsvfile, encoding);
      reader.addEventListener( 'load', function() {
        var data = reader.result.replaceAll('\r', '')
        var recordArray =  data.split('\n');
        let count = 0;
        for (let i = 0; i < recordArray.length; i++){
          let columns = recordArray[i].split('\t');
          if (columns.length == Object.keys(columnDef).length) {
            let item = {
              itemCode : columns[columnDef.itemCode],
              itemName : _this.getItemName(columns[columnDef.itemCode]),
              serial: columns[columnDef.serial],
              storageLocation: columns[columnDef.storage],
              warehousingDate: _this.convertDateFormat(columns[columnDef.warehousingDate]),
              leaseStartDate: _this.convertDateFormat(columns[columnDef.leaseStartDate]),
              leaseEndDate: _this.convertDateFormat(columns[columnDef.leaseEndDate]),
              leaseUpDate : _this.convertDateFormat(columns[columnDef.leaseUpDate])
            }
            parent.data.push(item);
            count++;
          }
        }
        appVue.loadingEnd()
        //
        _this.showMessage( count + "件のデータを読込みました。");
        parent.tsvfile = ""
      })
    },
    convertDateFormat: function(val) {
      if (!val) {
        return
      }
      var list = val.split("/")
      var y = list[0];
      var m = list[1] - 1;
      var d = list[2];
      var date = new Date(y, m, d);
      if (date.getFullYear() != y || date.getMonth() != m || date.getDate() != d) {
        return ""
      }
      return this.yyyy_hyp_MM_hyp_dd(date)
    },
    getItemName: function(itemCode, itemName){
      var item = this.itemData.find(item => {
        return item.itemCode == itemCode && !item.deleteFlag
      })

      if (item) {
        return item.itemName;
      }
    },
    onKeyupEnter: function() {
      if (this.serial) {
        let serialItems = this.serial.split('/');
        if(serialItems.length == 2){
          //　"/"が含まれていたらそれ以降の文字に変更する
          this.serial = serialItems[1]
        }
      }
    },
    onKeyupEnterRow: function(rowItem, index){
      if (rowItem.serial) {
        let serialItems = rowItem.serial.split('/');
        if(serialItems.length == 2){
          //　"/"が含まれていたらそれ以降の文字に変更する
          rowItem.serial = serialItems[1]
        }
        if(rowItem.serial){
          var copy = JSON.parse(JSON.stringify(rowItem));
          var copyIndex = index + 1;
          copy.serial = "";
          this.data.splice(index + 1, 0, copy)
          this.$nextTick(() => {
            document.getElementsByClassName("serial")[copyIndex].focus()
          });
        }
      }
    },
    clear: function(index){
      this.data.splice(index, 1);
    },
    deviceRegist: function(){
      var elements = document.getElementsByClassName("regist-validate")
      var result = this.selfMadeValidation(elements)
      var errMsg = result.msg
      if(result.isError){
        this.showErrorMessage('未入力の項目があります。')
      }else if (errMsg != ""){
        this.showErrorMessage('未入力の項目があります。')
      } else {
        if (this.itemInputCheck()) {
          var _this = this;
          var obj = JSON.parse(JSON.stringify(this.data));
          obj.forEach(item => {
            item.warehousingDate = item.warehousingDate ? item.warehousingDate.replace(/-/g, "/") : item.warehousingDate;
            item.leaseStartDate = item.leaseStartDate ? item.leaseStartDate.replace(/-/g, "/") : item.leaseStartDate;
            item.leaseEndDate = item.leaseEndDate ? item.leaseEndDate.replace(/-/g, "/") : item.leaseEndDate;
            item.leaseUpDate = item.leaseUpDate ? item.leaseUpDate.replace(/-/g, "/") : item.leaseUpDate;
          });

          this.apiCall(
            function(client){
              return client.apis.internalDeviceManagement.setDeviceAdditionPOST({
                body:obj
              });
            },
            function(result){
              _this.showSuccess(result, function(){});
            },
            function(result){
              _this.showErrorMessage(result);
            }
          );
        }
      }
    },
    itemInputCheck: function(){
      var cnt = {};

      for (var item of this.data) {
        // 入庫日
        if (item.warehousingDate) {
          if (item.leaseStartDate) {
            if (item.warehousingDate > item.leaseStartDate) {
              this.showErrorMessage('入庫日とリース開始日の関係に誤りがあります。')
              return false
            }
          }

          if (item.leaseEndDate) {
            if (item.warehousingDate > item.leaseEndDate) {
              this.showErrorMessage('入庫日とリース終了日の関係に誤りがあります。')
              return false
            }
          }

          if (item.leaseUpDate) {
            if (item.warehousingDate > item.leaseUpDate) {
              this.showErrorMessage('入庫日とリースアップ日の関係に誤りがあります。')
              return false
            }
          }
        }

        // リース開始日
        if (item.leaseStartDate) {
          if (item.leaseEndDate) {
            if (item.leaseStartDate > item.leaseEndDate) {
              this.showErrorMessage('リース開始日とリース終了日の関係に誤りがあります。')
              return false
            }
          }

          if (item.leaseUpDate) {
            if (item.leaseStartDate > item.leaseUpDate) {
              this.showErrorMessage('リース開始日とリースアップ日の関係に誤りがあります。')
              return false
            }
          }
        }

        // リース終了日
        if (item.leaseEndDate) {
          if (item.leaseUpDate) {
            if (item.leaseEndDate > item.leaseUpDate) {
              this.showErrorMessage('リース終了日とリースアップ日の関係に誤りがあります。')
              return false
            }
          }
        }

        cnt[item['serial']] = (cnt[item['serial']] || 0) + 1;
      }

      for(var key of Object.keys(cnt)) {
        var num = cnt[key];
        if (num >= 2) {
          this.showErrorMessage('同じシリアル番号が入力されています。シリアル番号=' + key);
          return false;
        }
      }

      return true;
    },
    getDeviceModels: function() {
      // Web Api Call
      var _this = this;
      this.apiCall(
        function(client){
          return client.apis.internalDeviceManagement.getDeviceModelsPOST({
            body:{}
          });
        },
        function(result){
          _this.itemData = result.obj
        },
        function(result){
          _this.showErrorMessage(result);
        }
      );
    },
  },
  data() {
    return {
      data : [],
      tsvfile: null,
      itemCode : "",
      itemName : "",
      serial: "",
      storage: "",
      warehousingDate: "",
      leaseStartDate: "",
      leaseEndDate: "",
      leaseUpDate : "",
      isPaginated : true,
      copyFlg: false,
      copyIndex: 0,
      itemData:[]
    };
  },
  filters: {},
  components: {
    deviceNavi: naviBar
  },
  mounted: async function() {
   await this.getDeviceModels();
  }
};
</script>
<style lang="scss" scoped>
.condition-area {
    display: flex;
}
.conditionTable th{
  width: 50px ;
}
.tsvimportButton {
    float:left;
}
#deviceAddTable {
    width: 1410px;
    max-height: 700px;
    overflow-x: hidden;
    overflow-y: scroll;
}


</style>


// WEBPACK FOOTER //
// src/components/mock/philips/device/DeviceAdd.vue